import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

export const Container = styled(Flex)`
  width: 60px;
  height: 120px;

  background-color: rgb(79 88 96 / 25%);
  border-radius: 9999px 0 0 9999px;
  opacity: 0;
  transition: all 0.15s ease-in-out;
  visibility: hidden;

  &.is-active {
    opacity: 1;
    visibility: visible;
  }
`;
